import { useEffect, useState } from 'react';

import FlatsFilters from './lib/FlatsFilters/FlatsFilters';
import SingleFlatRow from './lib/SingleFlatRow/SingleFlatRow';

import { TFlat } from '../../../../shared/types/flat';

import styles from './FlatsTable.module.css';
import { useFlatsDataContext } from '../../../../contexts/FlatsDataContext';

type TFlatsTable = {
    flats: TFlat[]
}

const FlatsTable: React.FC<TFlatsTable> = ({ flats }): JSX.Element => {
    const { contextHoveredFlat } = useFlatsDataContext();
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return flats ? (
        <div className={styles.wrapper}>
            <FlatsFilters />
            <div>
                <table>
                    <thead>
                        <tr>
                            <th>{isMobile ? 'Nr' : 'Numer'}</th>
                            <th>{isMobile ? 'Status' : 'Status'}</th>
                            <th>{isMobile ? 'Piętro' : 'Piętro'}</th>
                            <th>{isMobile ? 'Pok.' : 'Pokoje'}</th>
                            <th>{isMobile ? 'Pow.' : 'Pow.'}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {flats.map((flat) => (
                            <SingleFlatRow key={flat.id} flat={flat} isHovered={contextHoveredFlat?.name.toLowerCase() === flat.name.toLowerCase()} />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    ) : (
        <p>Brak mieszkań dla podanych filtrów.</p>
    );
};

export default FlatsTable;